import axios from 'axios'
import * as qs from 'qs'
import { DataSourceOpts } from '../overview'
import { getFilterParams } from './Filters'
import { CustomProfileFieldList } from './Columns'

export interface UserProfileFields {
  [key: string]: string | string[]
}

export interface UserData {
  user_id: number
  username: string
  email: string
  avatar: string
  last_visit: string
  last_activity: string
  join_date: string
  topics: number
  replies: number
  role: number
  rank_id: number
  custom_roles: number[]
  badges: number[]
  groups: number[]
  profile_fields: UserProfileFields
}

interface RequestParameter {
  page: number
  size: number
  sort?: string
  order?: string
  [key: string]: any
}

const getRequestParams = ({ pagination, sort, filters = {} }: DataSourceOpts, customProfileFields: CustomProfileFieldList): RequestParameter => {
  const queryParams: {
    page: number
    size: number
    sort?: string
    order?: string
    [key: string]: any
  } = {
    page: filters.usersIds?.length ? 1 : pagination.page,
    size: pagination.pageSize,
    ...getFilterParams(filters, customProfileFields)
  }

  if (sort) {
    const [sortKey, sortValue] = Object.entries(sort)[0]
    queryParams.sort = sortKey
    queryParams.order = sortValue
  }

  return queryParams
}

export const fetchData = async ({ pagination, sort, filters = {} }: DataSourceOpts, customProfileFields: CustomProfileFieldList) => {
  const queryParams = getRequestParams({ pagination, sort, filters }, customProfileFields)

  const response = await axios.get('/users/overview/get', {
    params: queryParams,

    paramsSerializer: params => {
      return qs.stringify(params, {
        arrayFormat: 'brackets'
      })
    }
  })

  return {
    data: response.data.items,
    total: response.data.totalItems
  }
}

export const exportData = async ({ pagination, sort, filters = {} }: DataSourceOpts, customProfileFields: CustomProfileFieldList) => {
  const queryParams = getRequestParams({ pagination, sort, filters }, customProfileFields)

  const { page, size, ...otherRequestParams } = queryParams

  const response = await axios.get('/users/overview/export', {
    params: otherRequestParams,
    paramsSerializer: params => {
      return qs.stringify(params, {
        arrayFormat: 'brackets'
      })
    }
  })

  return {
    data: response.data
  }
}
